// WebsiteSummaryTable.jsx
import React, { useState, useEffect } from "react";
import { getAllAssociations } from "./../../../../services/associationsServices";

const WebsiteSummaryTable = () => {
  const [websiteData, setWebsiteData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWebsiteData();
  }, []);

  const fetchWebsiteData = async () => {
    setLoading(true);
    const today = new Date().toISOString().split("T")[0];
    const allAssociations = await getAllAssociations();

    const websites = allAssociations.filter(
      (asso) =>
        asso.produit_asso === "Website" &&
        !!asso.apiUrl_asso &&
        asso.apiUrl_asso.startsWith("http")
    );

    const results = await Promise.all(
      websites.map(async (asso) => {
        const result = {
          name: asso.nom_asso,
          logo: asso.logo_asso,
          appUrl: asso.siteweb_asso,
          visitsToday: 0,
          visitsTotal: 0,
        };

        try {
          const res = await fetch(
            `${asso.apiUrl_asso}/api/visites/countVisitesByDate`
          );
          const data = await res.json();
          result.visitsToday =
            data.find((v) => v.date_visite === today)?.compteur || 0;
          result.visitsTotal = data.reduce(
            (acc, cur) => acc + Number(cur.compteur || 0),
            0
          );
        } catch (error) {
          console.error(`Erreur pour ${asso.nom_asso}:`, error.message);
        }

        return result;
      })
    );

    setWebsiteData(results);
    setLoading(false);
  };

  const totalStats = websiteData.reduce(
    (acc, site) => {
      acc.today += site.visitsToday || 0;
      acc.total += site.visitsTotal || 0;
      return acc;
    },
    { today: 0, total: 0 }
  );

  return (
    <div className="mt-8">
      <h2 className="text-2xl font-bold mb-4">Statistiques des produits Website</h2>
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-lg">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-3 px-6">Produit</th>
                <th className="py-3 px-6">Visites du jour</th>
                <th className="py-3 px-6">Visites totales</th>
              </tr>
            </thead>
            <tbody>
              {websiteData.map((site, index) => (
                <tr
                  key={index}
                  className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}
                >
                  <td className="py-3 px-6 flex items-center gap-2">
                    <img
                      src={site.logo}
                      alt={site.name}
                      className="w-10 h-10 rounded-full"
                    />
                    <a
                      href={site.appUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      {site.name}
                    </a>
                  </td>
                  <td className="py-3 px-6">{site.visitsToday}</td>
                  <td className="py-3 px-6">{site.visitsTotal}</td>
                </tr>
              ))}
              <tr className="bg-gray-200 font-bold">
                <td className="py-3 px-6">Total</td>
                <td className="py-3 px-6">{totalStats.today}</td>
                <td className="py-3 px-6">{totalStats.total}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WebsiteSummaryTable;
